<template>
  <header class="header" :class="screenWidth < 765 ? 'header-mb-box' : ''">
    <div class="shadow" v-if="currentTab"></div>
    <div v-if="screenWidth > 765" class="header-pc" @mouseleave="currentTab = null">
      <div class="menu">
        <div class="menu-box container-md">
          <div class="d-flex jc-between ai-center header-content" style="height: 100%">
            <div class="_left" @click="$router.push('/')">
              <img src="~@/assets/images/logo.png" alt />
            </div>
            <div class="_center">
              <ul class="nav d-flex">
                <!-- :class="{ 'curren-nav': activeTab == nav.path }" -->
                <li class="nav-list" v-for="(nav, index) in routerList" :key="nav.name" @click="
    goPageNav1(nav);
  saveTabInStore(nav.children && nav.children[0]);
  ">
                  <span @mouseenter="showTab(nav)" :class="flag == index ? 'activespan' : ''">{{ nav.title }}</span>
                </li>
              </ul>
            </div>
            <img src="@/assets/images/image-v2.0.0/JD_logo.png" alt="" class="jd-img"
              @click="goLink('https://mall.jd.com/index-11466759.html')" />
          </div>
          <div class="hover-box" v-if="currentTab">
            <router-link tag="div" v-for="(el, elIndex) in currentTab.children" :key="elIndex" class="hover-item"
              :to="goListPage(el)" @click.native="
    activeTab = currentTab.path;
  saveTabInStore(el);
  ">
              <div class="title" :class="{ 'border-active': el.border }">
                {{ el.name }}
              </div>
              <template v-if="el.children && el.children.length < 6">
                <router-link tag="div" v-for="jk in el.children" :key="jk.name" class="title-2" :to="goListPage(el, jk)"
                  @click.native="
    activeTab = currentTab.path;
  saveTabInStore(el);
  ">
                  <div>{{ jk.name }}</div>
                  <div class="specil-box">
                    <div v-for="js in jk.children" :key="js.name">
                      {{ js.name }}
                    </div>
                  </div>
                </router-link>
              </template>
              <div v-else class="row2">
                <div class="colum-row" v-for="(row, rowIndex) in computedELChildren(el.children)" :class="{
    'margin-left-px': (rowIndex + 1) % 2 == 0,
  }" :key="row.id">
                  <router-link tag="div" v-for="jk in row" :key="jk.name" class="title-2" :to="goListPage(el, jk)"
                    @click.native="
    activeTab = currentTab.path;
  saveTabInStore(el);
  ">
                    <div>{{ jk.name }}</div>
                    <div class="specil-box">
                      <div v-for="js in jk.children" :key="js.name">
                        {{ js.name }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div v-else class="header-mb" :class="{ show: subMenuShow }">
      <div class="d-flex jc-between ai-center h-100">
        <div class="left">
          <div class="_logo" @click="$router.push('/')">
            <img src="~@/assets/images/logo.png" alt="安道教育" />
          </div>
        </div>
        <div class="right" @click="subMenuShow = true">
          <Icon iconClass="menu2.0.0"></Icon>
        </div>
      </div>
    </div>
    <!-- //抽屉 -->
    <div class="submenu" :class="{ show: subMenuShow }">
      <div class="submenu-top">
        <img src="~@/assets/images/logo.png" alt class="mb-logo" />
        <div @click="subMenuShow = false">
          <Icon iconClass="close2.0.0"></Icon>
        </div>
      </div>
      <ul class="submenu-list">
        <li v-for="item in routerList" @click="showChildren(item)" :key="item.name" class="submenu-item-li">
          <div class="submenu-item">
            {{ item.title }}
            <icon v-if="item.children && !item.isShow" iconClass="add"></icon>
            <icon v-else-if="item.children && item.isShow" iconClass="subtraction"></icon>
          </div>
          <ul class="submenu-item-2-ul" v-if="item.isShow">
            <div v-for="(el, elsIndex) in item.children" @click.stop="showChildren(el, item)" :key="el.name"
              class="submenu-item-2-li" :class="{
    'no-border-bottom': elsIndex == item.children.length - 1,
  }">
              <div class="submenu-item-2-item">
                {{ el.name }}
                <icon v-if="el.children && !el.isShow" iconClass="add"></icon>
                <icon v-else-if="el.children && el.isShow" iconClass="subtraction"></icon>
              </div>
              <ul v-if="el.isShow" class="submenu-item-3-ul">
                <div tag="li" @click.stop="handleSecList(item, el, js)" class="submenu-item-3-li"
                  v-for="js in el.children" :key="js.name">
                  {{ js.name }}
                </div>
              </ul>
            </div>
          </ul>
        </li>
      </ul>
      <div class="serve-tel">服务热线 ：400-632-8880</div>
    </div>
  </header>
</template>
<script>
export default {
  props: ["screenWidth"],
  data() {
    return {
      subMenuShow: false,
      change: "",
      flag: -1, // 控制样式显示
      list: "",
      currentTab: null,
      routerList: [
        { path: "/zh/home", title: "首页" },
        {
          path: "/zh/product",
          title: "产品中心",
          isShow: false,
          children: [],
        },
        {
          path: "/zh/serve/video",
          title: "服务支持",
          isShow: false,
          children: [
            // { path: "/zh/trainList", name: "培训中心" },
            { path: "/zh/trainList", name: "在线学习平台" }, // 2024-5-17 培训中心改为在线学习平台
            { path: "/zh/service", name: "售后服务" },
            { path: "/zh/servicePolicy", name: "服务政策" },
            { path: "/zh/download", name: "下载专区" },
          ],
        },
        {
          path: "/zh/caseList",
          title: "案例专区",
          isShow: false,
          children: [],
        },
        {
          path: "/zh/about",
          title: "关于我们",
          isShow: false,
          children: [
            { path: "/zh/about/who", name: "公司介绍" },
            { path: "/zh/about/news", name: "新闻中心" },
            { path: "/zh/about/join", name: "加入我们" },
          ],
        },
      ],
      activeTab: null,
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.activeTab = this.$route.path;
      },
    },
  },
  created() {
    this.getTabList();
    this.getCaseTabList();
  },
  mounted() {
    this.activeTab = this.$route.path;
  },

  methods: {
    /**
     * @description: 如果超过5个标签需要横排展示
     * @param {*}
     * @return {*}
     */
    computedELChildren(list) {
      let arr = [],
        length = 5;
      if (list) {
        let tempList = JSON.parse(JSON.stringify(list));
        let arr1 = tempList.splice(0, length);
        let arr2 = tempList.splice(0, length);
        arr.push(arr1);
        arr.push(arr2);
      }
      return arr;
    },
    /**
     * @description: 获取案例中心的分类列表
     * @param {*}
     * @return {*}
     */
    async getCaseTabList() {
      // 3代表是案例
      let data = await this.$store.dispatch("getOfficialNewsCategory", {
        id: 3,
        type: "case",
      });
      data.map((el) => {
        el.path = `/zh/caseList`;
        el.name = el.newsCategoryName;
        delete el.newsCategoryName;
      });
      this.routerList.map((item) => {
        if (item.path == "/zh/caseList") {
          item.children = data;
        }
      });
    },
    /**
     * @description: 产品中心分类列表
     * @param {*}
     * @return {*}
     */
    async getTabList() {
      let list = await this.$store.dispatch("getProductNavList");
      list.push({
        path: "/zh/parts",
        name: "配件专区",
        children: [],
        isShow: false,
        border: true,
      });
      this.routerList[1].children = list;
    },
    goLink(link) {
      window.open(link, "_blank");
    },
    showChildren(item) {
      if (item.children && item.children.length != 0) {
        item.isShow = !item.isShow;
      } else {
        let path = `${item.path}?id=${item.newsCategoryId || ""}`;
        this.subMenuShow = !this.subMenuShow;
        this.goPageNav3(item, path);
      }
    },
    goPageNav1(nav1) {
      if (nav1.children) {
        let el = nav1.children[0];
        let path = `${el.path}?type=${el.flag || ""}&${el.productCategoryId
            ? "id=" + el.productCategoryId
            : el.productModuleId
              ? "id=" + el.productModuleId
              : el.newsCategoryId
                ? "id=" + el.newsCategoryId
                : ""
          }`;
        this.$router.push(path);
      } else {
        this.$router.push(nav1.path);
      }
    },
    handleSecList(nav1, nav2, nav3) {
      let path = `${nav2.path}?type=${nav2.flag}&id=${nav2.productCategoryId ||
        nav2.productModuleId}&path=${nav3.name}`;
      this.subMenuShow = !this.subMenuShow;
      this.goPageNav3(nav2, path);
    },
    goPageNav3(item, path) {
      this.activeTab = item.path;
      this.$router.push(path);
    },
    showTab(nav) {
      this.currentTab = nav.children ? nav : null;
    },
    saveTabInStore(nav) {
      this.$store.dispatch("saveTabInStore", nav);
    },
    goListPage(el, jk) {
      let path = `${el.path}?type=${el.flag || ""}&${el.productCategoryId
          ? "id=" + el.productCategoryId
          : el.productModuleId
            ? "id=" + el.productModuleId
            : el.newsCategoryId
              ? "id=" + el.newsCategoryId
              : ""
        }`;
      if (jk) {
        path = path + `&path=${jk.name}`;
      }
      return path;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./scss/layout-mb.scss";
@import "./scss/layout-pc.scss";

.header-mb {
  position: fixed;
  top: 0;
  z-index: 9;
  width: 100%;
}
</style>
